import React from 'react';

export default function BigWistiaSliceWithCopy(props) {
	const url = props.url;
	const copy = props.copy;
	const title = props.title;
	return (
		<div className="container wistia-with-copy-wrapper">
			<div className="wistia-with-copy-hold">
				<div className="row">
					<div className="col-12 col-lg-6 wistia-text">
						<div className="wistia-title">{title}</div>
						<div className="wistia-copy">{copy}</div>
					</div>
					<div className="col-12 col-lg-6 wistia-wrapper">
						<div className="wistia-player">
							<div
								className="wistia_responsive_padding"
								style={{ padding: '56.0% 0 0 0', position: 'relative' }}
							>
								<div
									className="wistia_responsive_wrapper"
									style={{
										height: '100%',
										left: '0',
										position: 'absolute',
										top: '0',
										width: '100%',
									}}
								>
									<iframe
										src={url}
										title="Wistia video player"
										allowtransparency="true"
										frameBorder="0"
										scrolling="no"
										className="wistia_embed"
										name="wistia_embed"
										allowFullScreen
										autoPlay={true}
										width="100%"
										height="100%"
									/>
								</div>
							</div>
							<script
								src="https://fast.wistia.net/assets/external/E-v1.js"
								async
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}



// WEBPACK FOOTER //
// src/client/components/slices/BigWistiaSliceWithCopy.js